export const CardError = {
  card_declined: '支払い不可能なカードです。',
  expired_card: '有効期限切れのカードです。',
  invalid_expiration_date: '不正な有効期限のカードです。',
  unableCard: '利用できないカードです。',
};
